// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ewmcode[data-v-3a6ae8c0]{width:150px;position:fixed;bottom:0;left:0;text-align:center;background:#f5f7fd}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
